<template>
  <div class="container-fluid">
    <!-- Content Header (Page header) -->
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="box info-box">
            <div class="box-header with-border">
              Search By
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-3">
                  <label for="Branch">Branch</label>
                  <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="loadStaff()"></v-select>
                  
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3" v-if="form.branch_id">
                  <label for="Type">Type</label>
                  <select
                    v-model="form.planType"
                    name="planType"
                    @change="getPlanType"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('planType'),
                    }"
                    required
                  >
                    <option v-if="!form.planType" selected value="">
                      Select plan Type
                    </option>
                    <option value="group">Group</option>
                    <option value="individual">Individual</option>
                  </select>
                  <has-error
                    :form="form"
                    field="planType"
                  ></has-error>
                </div>
                <div class="col-md-3" v-if="form.planType === 'group'">
                  <label for="Group">Group</label>
                  <v-select v-model="collectionCenter" name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Branch" v-on:input="getMembers">
                  </v-select>
                  <has-error
                    :form="form"
                    field="collection_center_id"
                  ></has-error>
                </div>
                <div class="col-md-3" v-if="canAccess('member-collection-approve')">
                  <div class="form-group">
                    <label>Staff ID <span class="red">*</span></label>
                    <v-select v-model="staf" name="agent_id" label="name" :options="staffs" placeholder="Select Staff" v-on:input="changeFilter()">

                    </v-select>
                    <has-error
                      :form="form"
                      field="agent_id"
                    ></has-error>
                  </div>
                </div>
                
                <div class="col-md-3">
                  <label for="date">Date</label>
                  <input type="date" v-model="emiDate" name="emiDate" class="form-control" @change="changeFilter()" placeholder="EMI Date">
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>

          <!-- /.card -->
          <!-- <div class="box box-success" v-if="canAccess('member-collection-approve')">
            <div class="box-body">
              <div class="card">
                <div class="card-header">
                  <span class="pull-right">
                  </span>
                  <h3 class="card-title">Approve Member Collection</h3>
                  
                </div>
                <div class="card-body table-sm">
                  <vue-good-table
                    :columns="columnsMemberCollections"
                    :rows="rowsMemberCollections"
                    styleClass="vgt-table condensed"
                    :line-numbers="true"
                    :pagination-options="{
                      enabled: true,
                      perPage: 10,
                      perPageDropdown: [10, 20, 30],
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      
                      <span v-if="props.column.field == 'paymentdate'">
                        <span>{{props.row.paymentDate | myDate }}</span>
                      </span>
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'pending'"
                          class="label label-warning"
                          >Pending</span
                        >
                        <span
                          v-if="props.row.status == 'paid'"
                          class="label label-success"
                          >Paid</span
                        >
                        <span
                          v-if="props.row.status == 'partial'"
                          class="label label-info"
                          >Partial</span
                        >
                      </span>
                      <span v-if="props.column.field == 'id'">
                        <button
                        @click="confirmPayment(props.row)"
                        class="btn btn-success btn-xs"
                        >
                        <i class="fa fa-check"> Confirm</i>
                        </button>
                      </span>
                      <span v-if="props.column.field == 'id'">
                        
                        <button
                        v-if="canAccess('member-collection-delete')"
                        @click="confirmPaymentDelete(props.row)"
                        class="btn btn-danger btn-xs"
                        >
                        <i class="fa fa-trash"> Delete</i>
                        </button>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div> -->
          <!-- Default box -->
          <div class="info-box"  v-if="canAccess('member-collection-approve')">
            <div class="box-header with-border">
              <h3 class="box-title">Collection List For Approved</h3>
              <div class="box-tools">
              </div>

            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-6 col-xs-6">
                  <!-- <label>
                    <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label> -->
                  <label>Amount: {{totalAmt}}</label>
                </div>
                <div class="col-sm-6 col-xs-6">
                  <div class="input-group pull-right input-group-sm" style="width: 150px;">
                    <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                    <div class="input-group-btn">
                      <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>
              <table class="table table-sm table-bordered table-hover">
                <thead style="background-color: #d6dddd;">
                  <tr>
                    <th class="hidden-xs">Sr. No.</th>
                    <th>LoanID</th>
                    <th>Mem Code</th>
                    <th class="hidden-xs">Mem Name</th>
                    <th class="hidden-xs">(C/O)Alias</th>
                    <th class="hidden-xs">Mobile</th>
                    <th class="hidden-xs">PayDate</th>
                    <th>Amount</th>
                    <th class="hidden-xs">ReceivedBy</th>
                    <th class="hidden-xs">EmpCode</th>
                    <th class="hidden-xs">PayMode</th>
                    <th class="hidden-xs">Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in rowsMemberCollections.data" :key="index">
                    <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                    <td><span v-if="row.member_loan_plan">{{ row.member_loan_plan.applicationNo }}</span></td>
                    <td>{{ row.member.code }}</td>
                    <td class="hidden-xs">{{ row.member.name }}</td>
                    <td class="hidden-xs">{{ row.member.alias }}</td>
                    <td class="hidden-xs">{{ row.member.mobile }}</td>
                    <td class="hidden-xs">{{ row.paymentDate | myDate }}</td>
                    <td>{{ row.amt }}</td>
                    <td class="hidden-xs"><span v-if="row.received_by">{{ row.received_by.name }}</span></td>
                    <td class="hidden-xs"><span v-if="row.received_by">{{ row.received_by.code }}</span></td>
                    <td class="hidden-xs"><span v-if="row.branch_ledger">{{ row.branch_ledger.ledger.name }}</span></td>
                    <td class="hidden-xs">
                      <span
                          v-if="row.status == 'pending'"
                          class="label label-warning"
                          >Pending</span
                        >
                        <span
                          v-if="row.status == 'paid'"
                          class="label label-success"
                          >Paid</span
                        >
                        <span
                          v-if="row.status == 'partial'"
                          class="label label-info"
                          >Partial</span
                        >
                    </td>
                    <td>
                      <div class="btn-group">
                        <button
                        @click="confirmPayment(row)"
                        class="btn btn-success btn-xs"
                        >
                        <i class="fa fa-check"></i>
                        </button>
                        <button
                        v-if="canAccess('member-collection-delete')"
                        @click="confirmPaymentDelete(row)"
                        class="btn btn-danger btn-xs"
                        >
                        <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
                    
            </div>
            <!-- /.box-body -->
            <div class="box-footer clearfix" v-if="pagination.current_page > 0">
              <div class="row">
                <div class="col-sm-4">
                  Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
                </div>
                <div class="col-sm-8">
                  <ul class="pagination pagination-sm no-margin pull-right">
                    <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                    <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                    <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                    <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                    <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                    <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                    <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                    <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                    <li><a href="#">...</a></li>
                    
                    <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                    <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                    <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                    <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                    <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                    <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- /.box-footer-->
          </div>
          <!-- /.box -->

        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import GetBranch from '../../mixins/BranchRecords'
var _ = require('lodash')
export default {
  name: 'ApproveCollection',
  mixins: [GetBranch],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 100,
      table_search: '',
      editMode: false,
      emiDate: null,
      collectionCenters: [],
      collectionCenter: {
        name: 'Select Group'
      },
      applicationNumber: '',
      memberCode: '',
      mobileNumber: '',
      adharCardNumber: '',
      pancardNumber: '',
      branches: [],
      branch: {},
      members: {},
      staffs: [],
      staf: {},
      banks: {},
      pl: {},
      seeRecord: {},
      loanplans: [],
      memberloanplans: [],
      memberloanplan: {},
      groupMembers: {},
      loadDisbursements: {},
      totalAmt: '',
      viewCollectionCenter: '',
      form: new Form({
        id: '',
        collection_center_id: '',
        member_loan_plan_id: null,
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        amt: '',
        plan: {},
        planType: '',
        member_id: '',
        status: '',
        disbursement_id: '',
        paymentDate: '',
        emiStartDate: '',
        paymentMode: '',
        bank_id: ''
      }),
      columns: [
        {
          label: 'EMI DATE',
          field: 'emiDate'
        },
        {
          label: 'PRINCIPAL',
          field: 'principal'
        },
        {
          label: 'INTEREST',
          field: 'intrest'
        },
        {
          label: 'TOTAL',
          field: 'total'
        },
        {
          label: 'ADJUSTMENT',
          field: 'adjustment'
        },
        {
          label: 'BALANCE',
          field: 'balance'
        },
        {
          label: 'RECEIVED',
          field: 'received'
        },
        {
          label: 'ARRIER',
          field: 'arrear'
        },
        {
          label: 'ADVANCE',
          field: 'advance'
        },
        {
          label: 'STATUS',
          field: 'Status'
        }
      ],
      rows: [],
      columnsMemberCollections: [
        {
          label: 'LOAN ID',
          field: 'member_loan_plan.applicationNo'
        },
        {
          label: 'MEM CODE',
          field: 'member.code'
        },
        {
          label: 'MEM NAME',
          field: 'member.name'
        },
        {
          label: '(C/O) ALIAS',
          field: 'member.alias'
        },
        {
          label: 'MEM MOB',
          field: 'member.mobile'
        },
        {
          label: 'PAYMENT DATE',
          field: 'paymentdate'
        },
        {
          label: 'AMOUNT',
          field: 'amt'
        },
        {
          label: 'RECEIVED BY',
          field: 'received_by.name'
        },
        {
          label: 'EMP CODE',
          field: 'received_by.code'
        },
        {
          label: 'PAYMENT MODE',
          field: 'branch_ledger.ledger.name'
        },
        {
          label: 'STATUS',
          field: 'Status'
        },
        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      rowsMemberCollections: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    confirmPayment (row) {
      Swal.fire({ title: 'Are you sure?', text: 'You Confirm this Payment !', icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, Save it!' })
      .then((result) => {
        let loader = this.$loading.show()
        if (result.isConfirmed) {
          this.$axios.post('membercollection/approve/' + row.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')
              loader.hide()
              Toast.fire({
                icon: 'success',
                title: 'Payment Record Approved Successfully'
              })
            })
        }
      })
    },
    confirmPaymentDelete (row) {
      Swal.fire({ title: 'Are you sure?', text: 'You Delete this Payment !', icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, Save it!' })
      .then((result) => {
        let loader = this.$loading.show()
        if (result.isConfirmed) {
          this.$axios.delete('membercollection/' + row.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')
              loader.hide()
              Toast.fire({
                icon: 'success',
                title: 'Payment Record Deleted Successfully'
              })
            })
        }
      })
    },
    loadStaff () {
      var c = JSON.parse(localStorage.user)
      this.form.agent_id = ''
      this.staffs = []
      this.staf = {}
      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      if (c.type === 'admin') {
        this.changeFilter()
      }
    },
    getMembers () {
      this.memberloanplans = []
      this.form.collection_center_id = ''
      if (this.collectionCenter) {
        this.form.collection_center_id = this.collectionCenter.id
      }
      this.form.member_loan_plan_id = ''
      this.rows = []
      this.rowsMemberCollections = []
      this.changeFilter()
      // if (this.emiDate) {
      //   this.getEMIRecord()
      // } else {
      //   this.getMemberLoanPlan()
      // }
    },
    getEMIRecord () {
      this.memberloanplans = []
      this.rows = []
      this.rowsMemberCollections = []
      this.form.member_loan_plan_id = ''
      if (this.emiDate) {
        this.$axios
        .get('memberemi?all=all&emiDate=' + this.emiDate + '&branch_id=' + this.form.branch_id + '&type=' + this.form.planType + '&collection_center_id=' + this.form.collection_center_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberloanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.getMemberLoanPlan()
      }
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      this.form.member_loan_plan_id = null
      return pln.name
    },
    // getSingleMemberLoanDetails () {
    //   if (this.emiDate) {
    //     alert('dobar')
    //     this.$axios
    //     .get('memberemi?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id + '&emiDate=' + this.emiDate, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       this.rows = data.data
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    //   } else {
    //     this.$axios
    //     .get('memberemi?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       this.rows = data.data
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    //   }
    //   if (this.branch.id) {
    //     this.$axios
    //     .get('membercollection?all=all&status=pending&branch_id=' + this.branch.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       this.rowsMemberCollections = data.data
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    //   } else {
    //     this.$axios
    //     .get('membercollection?all=all&status=pending', {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       this.rowsMemberCollections = data.data
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    //   }
    //   var ss = this.form.member_loan_plan_id
    //   if (this.memberloanplans.length >= 1) {
    //     if (!this.emiDate) {
    //       this.memberloanplan = _.find(this.memberloanplans, function (o) { return o.id === ss })
    //     }
    //   }
    //   this.form.member_id = this.memberloanplan.member_id
    //   this.form.disbursement_id = this.memberloanplan.disbursement_id
    //   if (this.form.planType === 'group') {
    //     if (this.form.collection_center_id === '' || this.form.collection_center_id === null) {
    //       this.form.collection_center_id = this.memberloanplan.collection_center_id
    //     }
    //   }
    // },
    changeFilter (page = null, pg = null) {
      // var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'membercollection'
      }

      if (pg == null) {
        pageUrl += `?status=pending&per_page=${this.per_page}`
      } else {
        pageUrl += `&status=pending&per_page=${this.per_page}`
      }
      if (this.branch.id) {
        pageUrl += `&branch_id=${this.branch.id}`
      }
      if (this.form.collection_center_id) {
        pageUrl += `&collection_center_id=${this.form.collection_center_id}`
      }
      if (this.form.planType) {
        pageUrl += `&loanType=${this.form.planType}`
      }
      if (this.staf.id) {
        pageUrl += `&receivedBy=${this.staf.user_id}`
      }
      if (this.emiDate) {
        pageUrl += `&paymentDate=${this.emiDate}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.rowsMemberCollections = data.data
          this.totalAmt = _.sumBy(this.rowsMemberCollections.data, function (o) { return o.amt })
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
      // if (c.type === 'admin') {
      //   this.loadBranch()
      // } if (c.type === 'staff') {
      //   this.form.branch_id = c.agent_profile.branch_id
      //   this.$axios
      //   .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      //   .then((response) => response.data)
      //   .then((data) => {
      //     this.staffs = data.data
      //     _.forEach(this.staffs, function (item, key) {
      //       this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
      //     }.bind(this))
      //   })
      //   .catch(
      //     function (error) {
      //       Toast.fire({ icon: 'error', title: 'Please Try Again' })
      //       this.form.errors.errors = error.response.data.error
      //     }.bind(this)
      //   )
      // }
    },
    getMemberLoanPlan () {
      this.$axios
        .get('memberloanplan?branch_id=' + this.form.branch_id + '&searchTerm=' + this.form.planType + '&collection_center_id=' + this.form.collection_center_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // this.memberloanplans = data.data
          this.rowsMemberCollections = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getLoanDetailsApplicationNumber () {
      this.form.member_loan_plan_id = []
      this.rows = []
      this.rowsMemberCollections = []
      this.$axios
      .get('memberloanplan?all=all&searchTerm=' + this.applicationNumber, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data.data)
          this.form.member_loan_plan_id = data.data[0]['id']
          this.$axios
          .get('memberloanplan?all=all/' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            // alert(data)
          // console.log('hellooo')
          // console.log(data.data)
            this.memberloanplan = data.data
            // console.log('memberloanplans' + this.memberloanplans)
            // this.getSingleMemberLoanDetails()
            this.changeFilter()
          })
          .catch(function (error) {
            console.log(error)
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getLoanDetailsMemberCode () {
      this.$axios
      .get('memberloanplan?all=all&applicationNo=' + this.memberCode, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
         // console.log(data.data.data)
         // alert(data.data.data)
          this.form.member_loan_plan_id = data.data[0]['id']
          // this.getSingleMemberLoanDetails()
          this.changeFilter()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getPlanType () {
      this.form.collection_center_id = ''
      this.form.member_loan_plan_id = ''
      this.memberloanplans = []
      this.rows = []
      this.rowsMemberCollections = []
      if (this.form.planType === 'individual') {
        this.collectionCenter = {'name': 'Select Group'}
      }
      if (this.form.planType === 'group') {
        this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.collectionCenters = data.data
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
      this.changeFilter()
      // if (this.emiDate) {
      //   this.getEMIRecord()
      // } else {
      //   this.getMemberLoanPlan()
      // }
      // this.form.member_id = null
    },
    getMemberAndGroupAndAgent () {
      this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.collectionCenters = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )

      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadGroupMember (id) {
      this.$axios
        .get('collectioncentermember?all=all&collection_center_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.groupMembers = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },

  created () {
    // this.getSingleMemberLoanDetails()
    this.getBranch('true')
    this.changeFilter()
    Fire.$on('AfterCreate', () => {
      // this.getSingleMemberLoanDetails()
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
    padding: 0px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 3px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// Collection.vue?5d3274d0